import { swRequest } from "@sourcewhale/core";

export const signOut = (toast) => {
  if (toast) {
    localStorage.setItem("signOutToast", JSON.stringify(toast));
  }
  return swRequest({
    path: "/api/users/sign_out",
  }).then(() => {
    localStorage.removeItem("provider");
    localStorage.removeItem("clarity");
    window.location = "/signin";
  });
};
